import { createSlice } from '@reduxjs/toolkit';

const groupSlice = createSlice({
    name: 'group',
    initialState: {
        groupId: null,
        scrollTop: null,
    },
    reducers: {
        setGroupId: (state, action) => {
            state.groupId = action.payload;
        },
        clearGroupId: (state) => {
            state.groupId = null;
        },
        setScrollTop: (state, action) => {
            state.scrollTop = action.payload;
        },
        clearScrollTop: (state) => {
            state.scrollTop = null;
        },
    },
});

export const { setGroupId, clearGroupId, setScrollTop, clearScrollTop } = groupSlice.actions;
export default groupSlice.reducer;
